import { useState } from 'react';
import { Link } from 'react-router-dom';
import { articles } from '@/mocks/data';

export default function HeroSection() {
  const featuredArticles = articles.filter((a) => a.featured).slice(0, 3);

  return (
    <section className="relative w-full h-[620px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Elegant%20Japanese%20aesthetic%20background%20with%20soft%20cherry%20blossom%20petals%20floating%20in%20warm%20golden%20light%2C%20silhouette%20of%20a%20graceful%20woman%20in%20the%20distance%2C%20ethereal%20atmosphere%2C%20cream%20and%20rose%20gold%20tones%2C%20minimalist%20artistic%20composition%2C%20dreamy%20and%20nostalgic%20mood&width=1600&height=900&seq=hero-main-01&orientation=landscape"
          alt="饭岛爱纪念 - 传奇人生"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>

      <div className="relative z-10 w-full px-4 md:px-6 text-center">
        <div className="max-w-4xl mx-auto">
          <p className="text-white/70 text-sm md:text-base font-label tracking-widest mb-4 uppercase">
            纪念日本最具传奇色彩的女性
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            饭岛爱
          </h1>
          <p className="text-white/80 text-base md:text-xl max-w-2xl mx-auto leading-relaxed mb-10">
            从AV女优到畅销作家、电视主持人，她的人生轨迹震撼了整个时代。
            她用真实的生命诠释了勇气的含义。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Link
              to="/category/life-experience"
              className="px-8 py-3 bg-primary-500 text-background-50 font-medium rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              探索她的人生
            </Link>
            <Link
              to="/about"
              className="px-8 py-3 border border-white/30 text-white font-medium rounded-md hover:bg-white/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              关于本站
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10 hidden lg:block">
        <div className="max-w-7xl mx-auto px-4 md:px-6 pb-8">
          <div className="grid grid-cols-3 gap-4">
            {featuredArticles.map((article, idx) => (
              <Link
                key={article.id}
                to={`/article/${article.slug}`}
                className="bg-white/10 backdrop-blur-md rounded-lg p-4 border border-white/20 hover:bg-white/20 transition-all cursor-pointer group"
              >
                <p className="text-white/50 text-xs mb-1 font-label">
                  {idx === 0 ? '热门文章' : idx === 1 ? '编辑推荐' : '最新发布'}
                </p>
                <h3 className="text-white text-sm font-medium line-clamp-2 group-hover:text-primary-300 transition-colors">
                  {article.title}
                </h3>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}